import styled from 'styled-components';
import MuiAutocomplete from '@mui/material/Autocomplete';
import MuiSelect from '@mui/material/Select';

export const Autocomplete = styled(MuiAutocomplete)`
  &.MuiAutocomplete-root {
    &.MuiAutocomplete-hasClearIcon {
      .MuiFormControl-root {
        .MuiOutlinedInput-root {
          padding-right: 38px;
        }
      }
    }
  }
  .MuiFormControl-root {
    .MuiInputBase-root {
      padding-top: 0;
      padding-bottom: 0;
      background: ${(props) => props.theme.input.background};

      .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${(props) => props.theme.input.border};
      }

      .MuiInputBase-input {
        padding: 8.5px 4px 8.5px 5px;
        font-size: 14px;

        &::placeholder {
          color: ${(props) => props.theme.input.placeholder};
          opacity: 1;
        }

        &:-ms-input-placeholder {
          color: ${(props) => props.theme.input.placeholder};
        }

        &::-ms-input-placeholder {
          color: ${(props) => props.theme.input.placeholder};
        }
      }

      &:hover,
      &:focus {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${(props) => props.theme.input.border};
          box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
        }
      }

      .MuiSvgIcon-root {
        color: ${(props) => props.theme.palette.text.primary};
      }
    }
  }

  &:not(.MuiAutocomplete-hasClearIcon) {
    .MuiFormLabel-root {
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &.Mui-focused {
    .MuiFormControl-root {
      .MuiInputBase-root {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${(props) => props.theme.input.border};
          box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
        }
      }
    }
  }
`;

export const Select = styled(MuiSelect)`
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${(props) => props.theme.input.border};
  }
  .MuiSelect-select {
    padding: 12px 4px 12px 15px;
    font-size: 14px;
    background: ${(props) => props.theme.input.background};
  }
`;
